var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-tab"},_vm._l((_vm.data),function(item,i){return _c('div',{key:i,staticClass:"item",class:{'is-select':_vm.$route.path == item.path},on:{"click":function($event){$event.stopPropagation();return _vm.$router.push({path:item.path})}}},[_vm._v(_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }